module.exports = __webpack_public_path__ + "img/pluto68.e9118389.jpg";